

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBankInput', function () {
    return {
        template: _template2['default'],
        scope: {
            user: '=?',
            bank: '=?'
        },
        /* auto formatting the user entered IBAN input */
        link: function link(scope, element, attr) {
            var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';

            element.on('keyup', function (event) {

                $('#ibanNumber').mask(IBANMask, {
                    'translation': {
                        0: { pattern: /[A-Za-z0-9]/ }
                    }
                });
            });
        },

        controller: ['$scope', function ($scope) {
            $scope.showIBAN = true;

            var days = [];
            var months = [];
            var years = [];

            var i;

            for (i = 1; i <= 31; i += 1) {
                var d = i < 10 ? '0' + i : i.toString();

                days.push(d);
            }

            for (i = 1; i <= 12; i += 1) {
                var m = i < 10 ? '0' + i : i.toString();

                months.push(m);
            }

            var year = new Date().getFullYear();

            for (i = year - 17; i >= year - 100; i -= 1) {
                years.push(i);
            }

            $scope.days = days;
            $scope.months = months;
            $scope.years = years;

            $scope.toggleIBAN = function () {
                $scope.showIBAN = !$scope.showIBAN;
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js
// module chunks = 0